<template>
  <div class="login-view">
    <div class="md-layout md-alignment-top">
      <div class="left-side md-layout-item md-medium-size-50 md-small-size-100">
        <md-content>
          <div class="content-container">
            <div v-if="!validated && !error">
                <md-progress-spinner
                  v-if="loading"
                  :md-diameter="40"
                  :md-stroke="3.5"
                  md-mode="indeterminate"
                />
                <h2>Almost done!</h2>
                <p>
                  Your email is being verfied. We should be ready any minute now.
                </p>
            </div>
            <div v-if="!validated && error">
                <h2>Oops! Something went wrong :-(</h2>
                <p>
                  The verification of this email did not work out.
                </p>

                <error-container :error="error"></error-container>

            </div>
            <div v-if="validated">
              <h2>Your email was verified successfully :-)</h2>
              <p>
                {{ message }}
                You can now
                <router-link to="/login">
                  sign in.
                </router-link>
              </p>
            </div>
          </div>
        </md-content>
      </div>
      <div class="right-side md-layout-item md-medium-size-50 md-small-hide">
        <img src="/static/login-picture-01.jpg" alt="A Team Working Together." rel="preload">
      </div>
    </div>
  </div>
</template>

<script>
import ErrorContainer from '../ErrorContainer'
import ErrorFactory from '../../models/ErrorFactory'

export default {
  name: 'ValidationView',
  mounted () {
    this.validateEmail()
  },
  components: {
    ErrorContainer
  },
  data () {
    return {
      validated: false,
      loading: false,
      message: '',
      errorFactory: new ErrorFactory(),
      error: null
    }
  },
  computed: {
    token () {
      return this.$route.params.token
    },
    axios () {
      return this.$store.getters['axios']
    },
    base_url () {
      return this.$store.getters['base_url']
    }
  },
  methods: {
    async validateEmail () {
      this.loading = true
      this.error = null
      try {
        const { data } = await this.axios.get(this.base_url + '/validation/' + this.token)

        if (data && data.firstname) {
          this.message = `It is nice to have you on board, ${data.firstname}!`
        }

        this.validated = true
      } catch (error) {
        this.error = this.errorFactory.make(error.response.data, 'Email Verification failed!')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.left-side,
.right-side {
  height: 100vh;
}
.left-side .md-content {
  height: 100%;
  width: 100%;
  background-color: white;
  position: relative;
}
.right-side img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
}
.content-container {
  width: 360px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: left;
}
.content-container {
  padding-left: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/Validate.vue